<template src="./ConfirmationModal.html">
</template>

<script>
/* testing */
export default {
  name: "confirmation-modal",
  data() {
    return {
    };
  },
  props: {
    message: {
      type: [String, Array],
      required: true,
    },
    title: {
      type: String,
    },
  },
  methods: {
    showConfirmationModal(confirmAction, cancelAction = () => {}, confirmParameter) {
      this.$bvModal.msgBoxConfirm(this.message, {
        title: this.title,
        centered: true,
        okTitle: this.$t("OK"),
        cancelTitle: this.$t("Cancel")
      })
      .then(value => {
        if (value) {
          if (confirmAction) {
            confirmAction(confirmParameter);
          }
        } else {
          if (cancelAction) {
            cancelAction();
          }
        }
      })
      // TODO handle error?
      .catch(error => console.log(error))
    },
    showConfirmationModalManual(mes, confirmAction, cancelAction = () => { }, confirmParameter) {
      this.$bvModal.msgBoxConfirm(mes, {
        title: this.title,
        centered: true,
        okTitle: this.$t("OK"),
        cancelTitle: this.$t("Cancel")
      })
        .then(value => {
          if (value) {
            if (confirmAction) {
              confirmAction(confirmParameter);
            }
          } else {
            if (cancelAction) {
              cancelAction();
            }
          }
        })
        // TODO handle error?
        .catch(error => console.log(error))
    }
  },
};
</script>
